import api from './api';

export const reviewService = {
  // Public: reviews + summary for a product, by slug
  getProductReviews: async (slug, params = {}) => {
    const response = await api.get(`/products/${slug}/reviews`, { params });
    return response.data?.data || response.data;
  },

  // Auth: can the current user review this product, and have they already?
  getEligibility: async productId => {
    const response = await api.get(`/reviews/eligibility/${productId}`);
    return response.data?.data || response.data;
  },

  // Auth: create a review (backend enforces the delivered-order rule)
  createReview: async ({ product_id, rating, title, comment }) => {
    const response = await api.post('/reviews', {
      product_id,
      rating,
      title,
      comment,
    });
    return response.data?.data || response.data;
  },

  // Auth: update your own review
  updateReview: async (reviewId, { rating, title, comment }) => {
    const response = await api.put(`/reviews/${reviewId}`, {
      rating,
      title,
      comment,
    });
    return response.data?.data || response.data;
  },

  // Auth: delete your own review
  deleteReview: async reviewId => {
    const response = await api.delete(`/reviews/${reviewId}`);
    return response.data?.data || response.data;
  },
};
